module.exports = {"classifyName":"","title":"","pageScene":"","startTime":"","endTime":"","backgroundColor":"#FFFFFF","shareTitle":"","shareContent":"","shareImg":"","navigatorBarTranslucent":"是","searchBoxDisplay":"否","searchWords":"","searchGuideText":"","searchGuideColor":"","navigatorBarTheme":"黑","abTestEnable":"否","abPreviewValue":"A","abPercent":50,"commentEnable":"否","ruleEntryShow":"否","ruleEntryHref":"","dataSource":[],"dataSourceStr":"","createTime":""}


//////////////////
// WEBPACK FOOTER
// ./templates/zhuanti/src/config/base-config-test.json
// module id = 928
// module chunks = 2